import config from 'Config';

import { STATE_INITIAL } from 'Store/commonActions';
import {
  MATCH_FILTER_ARCHIVED_MATCHES,
  MATCH_FILTER_WITH_MESSAGES,
  MATCH_FILTER_WITHOUT_MESSAGES,
} from 'Store/match/constants';

import type { UpdateState } from './types';

const initialState: UpdateState = {
  lastActivityDate: null,
  lists: {
    [MATCH_FILTER_WITH_MESSAGES]: {
      status: STATE_INITIAL,
      nextPageToken: null,
      isEndOfList: true,
    },
    [MATCH_FILTER_WITHOUT_MESSAGES]: {
      status: STATE_INITIAL,
      nextPageToken: null,
      isEndOfList: true,
    },
    [MATCH_FILTER_ARCHIVED_MATCHES]: {
      status: STATE_INITIAL,
      nextPageToken: null,
      isEndOfList: false,
    },
  },
  newFlags: {},
  pollInterval: {
    persistent: config.updateDelay,
    standard: config.updateDelay,
  },
};

export default initialState;
